import { IGetLaundriesData, IGetLaundriesQueryParams } from "types/laundry"

export interface ILaundiesProviderProps {
  children: JSX.Element
}

export enum LaundryStatus {
  ALL = "ALL",
  OPEN = "OPEN",
  CLOSE = "CLOSE"
}

export interface ILaundriesContext {
  laundries: IGetLaundriesData
  query: IGetLaundriesQueryParams
  searchValue: string
  isOpenedChecked: boolean
  isClosedChecked: boolean
  handleLaundriesPageChange: () => void
  deleteLaundry: (laundryId: number) => void
  handleSearchChange: (e: any) => void
  handleStatusCheckboxClick: (status: string) => void
}

export interface ILaundriesState {
  laundries: IGetLaundriesData
  searchValue: string
  status: LaundryStatus
  isOpenedChecked: boolean
  isClosedChecked: boolean
}